module.exports = __webpack_public_path__ + "static/media/442004739_940775471125782_6529593413767395614_n.038f80d0.jpg";